export const ARCHIVE_JOB_REQUEST = 'ARCHIVE_JOB_REQUEST';
export const ARCHIVE_JOB_RESPONSE = 'ARCHIVE_JOB_RESPONSE';
export const UNARCHIVE_JOB_REQUEST = 'UNARCHIVE_JOB_REQUEST';
export const UNARCHIVE_JOB_RESPONSE = 'UNARCHIVE_JOB_RESPONSE';
export const ARCHIVE_JOB_RESET = 'ARCHIVE_JOB_RESET';
